import i18n from 'i18next'

import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import de_CH from './assets/i18n/de_CH.json'
import en_US from './assets/i18n/en_US.json'
import fr_CH from './assets/i18n/fr_CH.json'

export const resources = {
  de: {
    name: 'Deutsch',
    translation: de_CH,
  },
  en: {
    name: 'English',
    translation: en_US,
  },
  fr: {
    name: 'Francais',
    translation: fr_CH,
  },
} as const

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  // 	.use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init(
    {
      // use the already configured language or fallback to german
      lng: localStorage.getItem('i18nextLng') || 'de',
      fallbackLng: 'de',
      // load: 'all',
      // debug: true,
      react: {
        useSuspense: true,
      },
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      resources,
    },
    (error) => {
      if (error) {
        console.error(
          'Error on initializing i18next (language library).',
          error
        )
      }
      // resources are loaded
    }
  )

export default i18n